export const formatForTable = function (value: string | number, digits: null | number = null): string | number {
  if (Number.isNaN(Number(value))) {
    return value;
  }

  if (Number(value) === 0) {
    return 0;
  }

  if (Number(value) < 1e-4) {
    return Number(value).toExponential(2);
  }

  if (!digits) {
    return Number(Number(value).toPrecision(4)).toLocaleString();
  }

  return Number(Number(value).toFixed(digits)).toLocaleString();
};


export const formatStrainResult = function(value: number): string{
  // convert to uStrain
  const ustrain = value * 1000000;

  //lop off extra digits
  const ustrainTruncated = ustrain.toFixed(0)

  //add exponent and return
  return `${ustrainTruncated}e-6`

}
